module.exports = __webpack_public_path__ + "img/57.32d6ed4c.jpg";